//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'App',
    data() {
        return {
            dataList: {
                currency: [
                    {
                        text: 'AUD Australian Dollar',
                        value: 'AUD'
                    },
                    {
                        text: 'EUR Euro',
                        value: 'EUR'
                    },
                    {
                        text: 'GBP Sterling',
                        value: 'GBP'
                    },
                    {
                        text: 'USD US Dollar',
                        value: 'USD'
                    },
                ],
                partnerType: [
                    {value: 'EMAIL', text: 'Email'},
                    {value: 'SEARCH', text: 'Search Engine Marketing'},
                    {value: 'LOYALTY', text: 'Loyalty/Rewards'},
                    {value: 'COUPON', text: 'Coupon/Deals'},
                    {value: 'SYNDICATION_BLOG_NETWORKS', text: 'Syndication/Blog Networks'},
                    {value: 'CPA_NETWORK', text: 'CPA/Sub-Affiliate Networks'},
                    {value: 'MOBILE', text: 'Mobile'},
                    {value: 'CONTENT', text: 'Content'},
                    {value: 'SHOPPING', text: 'Shopping/Comparison'},
                    {value: 'SOCIAL_MEDIA_INFLUENCER', text: 'Social Media/Influencer'},
                    {value: 'SERVICE_PROVIDER', text: 'Service Providers/Tools'},
                    {value: 'CONSUMER_SOFTWARE', text: 'Consumer Software / Technology'},
                    {value: 'INCENTIVIZED', text: 'Incentivized'},
                    {value: 'OFFLINE', text: 'Offline'},
                    {value: 'OTHER', text: 'Other'}
                ],
                country: [
                    {value: 'US', text: 'United States'},
                    {value: 'UK', text: 'United Kingdom'},
                    {value: 'CANADA', text: 'Canada'},
                    {value: 'AUSTRALIA', text: 'Australia'},
                    {value: 'GERMANY', text: 'Germany'},
                    {value: 'FRANCE', text: 'France'},
                    {value: 'ALBANIA', text: 'Albania'},
                    {value: 'ALGERIA', text: 'Algeria'},
                    {value: 'AMERICANSAMOA', text: 'American Samoa'},
                    {value: 'ANDORRA', text: 'Andorra'},
                    {value: 'ANGOLA', text: 'Angola'},
                    {value: 'ANGUILLA', text: 'Anguilla'},
                    {value: 'ANTARCTICA', text: 'Antarctica'},
                    {value: 'ANTIGUABARBUDA', text: 'Antigua and Barbuda'},
                    {value: 'ARGENTINA', text: 'Argentina'},
                    {value: 'ARMENIA', text: 'Armenia'},
                    {value: 'ARUBA', text: 'Aruba'},
                    {value: 'AUSTRIA', text: 'Austria'},
                    {value: 'AZERBAIJAN', text: 'Azerbaijan'},
                    {value: 'BAHAMAS', text: 'Bahamas'},
                    {value: 'BAHRAIN', text: 'Bahrain'},
                    {value: 'BANGLADESH', text: 'Bangladesh'},
                    {value: 'BARBADOS', text: 'Barbados'},
                    {value: 'BELGIUM', text: 'Belgium'},
                    {value: 'BELIZE', text: 'Belize'},
                    {value: 'BENIN', text: 'Benin'},
                    {value: 'BERMUDA', text: 'Bermuda'},
                    {value: 'BHUTAN', text: 'Bhutan'},
                    {value: 'BOLIVIA', text: 'Bolivia'},
                    {value: 'BOSNIAHERZEGOVINA', text: 'Bosnia and Herzegovina'},
                    {value: 'BOTSWANA', text: 'Botswana'},
                    {value: 'BRAZIL', text: 'Brazil'},
                    {value: 'BRITISHINDIANOCEANTERRITORY', text: 'British Indian Ocean Territory'},
                    {value: 'BRUNEIDARUSSALAM', text: 'Brunei Darussalam'},
                    {value: 'BULGARIA', text: 'Bulgaria'},
                    {value: 'BURKINAFASO', text: 'Burkina Faso'},
                    {value: 'BURUNDI', text: 'Burundi'},
                    {value: 'CAMBODIA', text: 'Cambodia'},
                    {value: 'CAMEROON', text: 'Cameroon'},
                    {value: 'CAPVERDE', text: 'Cape Verde'},
                    {value: 'CAYMANISLANDS', text: 'Cayman Islands'},
                    {value: 'CENTRALAFRICANREPUBLIC', text: 'Central African Republic'},
                    {value: 'CHAD', text: 'Chad'},
                    {value: 'CHILE', text: 'Chile'},
                    {value: 'CHINA', text: 'China'},
                    {value: 'CHRISTMASISLAND', text: 'Christmas Island'},
                    {value: 'COCOSISLANDS', text: 'Cocos Islands'},
                    {value: 'COLOMBIA', text: 'Colombia'},
                    {value: 'COMOROS', text: 'Comoros'},
                    {value: 'COOKISLANDS', text: 'Cook Islands'},
                    {value: 'COSTARICA', text: 'Costa Rica'},
                    {value: 'CROATIA', text: 'Croatia'},
                    {value: 'CYPRUS', text: 'Cyprus'},
                    {value: 'CZECHREPUBLIC', text: 'Czech Republic'},
                    {value: 'DENMARK', text: 'Denmark'},
                    {value: 'DIJIBOUTI', text: 'Djibouti'},
                    {value: 'DOMINICA', text: 'Dominica'},
                    {value: 'DOMINICANREPUBLIC', text: 'Dominican Republic'},
                    {value: 'ECUADOR', text: 'Ecuador'},
                    {value: 'EGYPT', text: 'Egypt'},
                    {value: 'ELSALVADOR', text: 'El Salvador'},
                    {value: 'EQUATORIALGUINEA', text: 'Equatorial Guinea'},
                    {value: 'ERITREA', text: 'Eritrea'},
                    {value: 'ESTONIA', text: 'Estonia'},
                    {value: 'ETHIOPIA', text: 'Ethiopia'},
                    {value: 'FALKLANDISLANDS', text: 'Falkland Islands'},
                    {value: 'FAROEISLANDS', text: 'Faroe Islands'},
                    {value: 'FIJI', text: 'Fiji'},
                    {value: 'FINLAND', text: 'Finland'},
                    {value: 'FRENCHGUIANA', text: 'French Guiana'},
                    {value: 'FRENCHPOLYNESIA', text: 'French Polynesia'},
                    {value: 'FRENCHSOUTHERNTERRITORIES', text: 'French Southern Territories'},
                    {value: 'GABON', text: 'Gabon'},
                    {value: 'GAMBIA', text: 'Gambia'},
                    {value: 'GEORGIA', text: 'Georgia'},
                    {value: 'GHANA', text: 'Ghana'},
                    {value: 'GIBRALTAR', text: 'Gibraltar'},
                    {value: 'GREECE', text: 'Greece'},
                    {value: 'GREENLAND', text: 'Greenland'},
                    {value: 'GRENADA', text: 'Grenada'},
                    {value: 'GUADELOUPE', text: 'Guadeloupe'},
                    {value: 'GUAM', text: 'Guam'},
                    {value: 'GUATEMALA', text: 'Guatemala'},
                    {value: 'GUERNSEY', text: 'Guernsey'},
                    {value: 'GUINEA', text: 'Guinea'},
                    {value: 'GUINEABISSAU', text: 'Guinea-Bissau'},
                    {value: 'GUYANA', text: 'Guyana'},
                    {value: 'HAITI', text: 'Haiti'},
                    {value: 'VATICAN', text: 'Holy See (Vatican City State)'},
                    {value: 'HONDURAS', text: 'Honduras'},
                    {value: 'HONGKONG', text: 'Hong Kong'},
                    {value: 'HUNGARY', text: 'Hungary'},
                    {value: 'ICELAND', text: 'Iceland'},
                    {value: 'INDIA', text: 'India'},
                    {value: 'INDONESIA', text: 'Indonesia'},
                    {value: 'IRELAND', text: 'Ireland'},
                    {value: 'ISRAEL', text: 'Israel'},
                    {value: 'ITALY', text: 'Italy'},
                    {value: 'JAMAICA', text: 'Jamaica'},
                    {value: 'JAPAN', text: 'Japan'},
                    {value: 'JORDAN', text: 'Jordan'},
                    {value: 'KAZAKHSTAN', text: 'Kazakhstan'},
                    {value: 'KENYA', text: 'Kenya'},
                    {value: 'KIRIBATI', text: 'Kiribati'},
                    {value: 'SOUTHKOREA', text: 'Korea, Republic of'},
                    {value: 'KUWAIT', text: 'Kuwait'},
                    {value: 'KYRGYZSTAN', text: 'Kyrgyzstan'},
                    {value: 'LAOS', text: 'Lao, People\'s Democratic Republic'},
                    {value: 'LATVIA', text: 'Latvia'},
                    {value: 'LESOTHO', text: 'Lesotho'},
                    {value: 'LIBERIA', text: 'Liberia'},
                    {value: 'LIBYA', text: 'Libyan Arab Jamahiriya'},
                    {value: 'LICHTENSTEIN', text: 'Liechtenstein'},
                    {value: 'LITHUANIA', text: 'Lithuania'},
                    {value: 'LUXEMBOURG', text: 'Luxembourg'},
                    {value: 'MACAO', text: 'Macau'},
                    {value: 'MACEDONIA', text: 'Macedonia, The Former Yugoslav Republic of'},
                    {value: 'MADAGASCAR', text: 'Madagascar'},
                    {value: 'MALAWI', text: 'Malawi'},
                    {value: 'MALAYSIA', text: 'Malaysia'},
                    {value: 'MALDIVES', text: 'Maldives'},
                    {value: 'MALI', text: 'Mali'},
                    {value: 'MALTA', text: 'Malta'},
                    {value: 'MARSHALLISLANDS', text: 'Marshall Islands'},
                    {value: 'MARTINIQUE', text: 'Martinique'},
                    {value: 'MAURITANIA', text: 'Mauritania'},
                    {value: 'MAURITIUS', text: 'Mauritius'},
                    {value: 'MAYOTTE', text: 'Mayotte'},
                    {value: 'MEXICO', text: 'Mexico'},
                    {value: 'MICRONESIA', text: 'Micronesia, Federated States of'},
                    {value: 'MOLDOVA', text: 'Moldova, Republic of'},
                    {value: 'MONACO', text: 'Monaco'},
                    {value: 'MONGOLIA', text: 'Mongolia'},
                    {value: 'MONTENEGRO', text: 'Montenegro'},
                    {value: 'MONTSERRAT', text: 'Montserrat'},
                    {value: 'MOROCCO', text: 'Morocco'},
                    {value: 'MOZAMBIQUE', text: 'Mozambique'},
                    {value: 'NAMIBIA', text: 'Namibia'},
                    {value: 'NAURU', text: 'Nauru'},
                    {value: 'NEPAL', text: 'Nepal'},
                    {value: 'NETHERLANDS', text: 'Netherlands'},
                    {value: 'NETHERLANDSANTILLES', text: 'Netherlands Antilles'},
                    {value: 'NEWCALEDONIA', text: 'New Caledonia'},
                    {value: 'NEWZEALAND', text: 'New Zealand'},
                    {value: 'NICARAGUA', text: 'Nicaragua'},
                    {value: 'NIGER', text: 'Niger'},
                    {value: 'NIGERIA', text: 'Nigeria'},
                    {value: 'NIUE', text: 'Niue'},
                    {value: 'NORFOLKISLAND', text: 'Norfolk Island'},
                    {value: 'NORTHERNMARIANAISLANDS', text: 'Northern Mariana Islands'},
                    {value: 'NORWAY', text: 'Norway'},
                    {value: 'OMAN', text: 'Oman'},
                    {value: 'PAKISTAN', text: 'Pakistan'},
                    {value: 'PALAU', text: 'Palau'},
                    {value: 'PALESTINIANTERRITORY', text: 'Palestinian Territory'},
                    {value: 'PANAMA', text: 'Panama'},
                    {value: 'PAPUANEWGUINEA', text: 'Papua New Guinea'},
                    {value: 'PARAGUAY', text: 'Paraguay'},
                    {value: 'PERU', text: 'Peru'},
                    {value: 'PHILIPPINES', text: 'Philippines'},
                    {value: 'PITCAIRN', text: 'Pitcairn'},
                    {value: 'POLAND', text: 'Poland'},
                    {value: 'PORTUGAL', text: 'Portugal'},
                    {value: 'PUERTORICO', text: 'Puerto Rico'},
                    {value: 'QATAR', text: 'Qatar'},
                    {value: 'REUNION', text: 'Réunion'},
                    {value: 'ROMANIA', text: 'Romania'},
                    {value: 'RUSSIA', text: 'Russian Federation'},
                    {value: 'RWANDA', text: 'Rwanda'},
                    {value: 'SAINTHELENA', text: 'Saint Helena'},
                    {value: 'SAINTKITTSNEVIS', text: 'Saint Kitts and Nevis'},
                    {value: 'SAINTLUCIA', text: 'Saint Lucia'},
                    {value: 'SAINTPIERREMIQUELON', text: 'Saint Pierre and Miquelon'},
                    {value: 'SAINTVINCENTGRENADINES', text: 'Saint Vincent and the Grenadines'},
                    {value: 'SAMOA', text: 'Samoa'},
                    {value: 'SANMARINO', text: 'San Marino'},
                    {value: 'SAOTOME', text: 'Sao Tome and Principe'},
                    {value: 'SAUDIARABIA', text: 'Saudi Arabia'},
                    {value: 'SENEGAL', text: 'Senegal'},
                    {value: 'YOGOSLAVIA', text: 'Serbia'},
                    {value: 'SEYCHELLES', text: 'Seychelles'},
                    {value: 'SIERRALEONE', text: 'Sierra Leone'},
                    {value: 'SINGAPORE', text: 'Singapore'},
                    {value: 'SLOVAKIA', text: 'Slovakia'},
                    {value: 'SLOVENIA', text: 'Slovenia'},
                    {value: 'SOLOMONISLANDS', text: 'Solomon Islands'},
                    {value: 'SOUTHAFRICA', text: 'South Africa'},
                    {value: 'SPAIN', text: 'Spain'},
                    {value: 'SRILANKA', text: 'Sri Lanka'},
                    {value: 'SURINAME', text: 'Suriname'},
                    {value: 'SVALBARDJANMAYEN', text: 'Svalbard and Jan Mayen'},
                    {value: 'SWAZILAND', text: 'Swaziland'},
                    {value: 'SWEDEN', text: 'Sweden'},
                    {value: 'SWITZERLAND', text: 'Switzerland'},
                    {value: 'TAIWAN', text: 'Taiwan'},
                    {value: 'TAJIKISTAN', text: 'Tajikistan'},
                    {value: 'TANZANIA', text: 'Tanzania, United Republic of'},
                    {value: 'THAILAND', text: 'Thailand'},
                    {value: 'TIMOR', text: 'Timor-Leste'},
                    {value: 'TOGO', text: 'Togo'},
                    {value: 'TOKELAU', text: 'Tokelau'},
                    {value: 'TONGA', text: 'Tonga'},
                    {value: 'TRINIDADTOBAGO', text: 'Trinidad and Tobago'},
                    {value: 'TUNISIA', text: 'Tunisia'},
                    {value: 'TURKEY', text: 'Turkey'},
                    {value: 'TURKMENISTAN', text: 'Turkmenistan'},
                    {value: 'TURKSCAICOSISLANDS', text: 'Turks and Caicos Islands'},
                    {value: 'TUVALU', text: 'Tuvalu'},
                    {value: 'UGANDA', text: 'Uganda'},
                    {value: 'UKRAINE', text: 'Ukraine'},
                    {value: 'UAE', text: 'United Arab Emirates'},
                    {value: 'URUGUAY', text: 'Uruguay'},
                    {value: 'UZBEKISTAN', text: 'Uzbekistan'},
                    {value: 'VANUATU', text: 'Vanuatu'},
                    {value: 'VENEZUELA', text: 'Venezuela'},
                    {value: 'VIETNAM', text: 'Vietnam'},
                    {value: 'BRITISHVIRGINISLANDS', text: 'Virgin Islands, British'},
                    {value: 'USVIRGINISLANDS', text: 'Virgin Islands, U.S.'},
                    {value: 'WALLISFUTUNA', text: 'Wallis and Futuna'},
                    {value: 'WESTERNSAHARA', text: 'Western Sahara'},
                    {value: 'YEMEN', text: 'Yemen'},
                    {value: 'ZAMBIA', text: 'Zambia'}
                ],
                state: [
                    {value: 'CAPITALTERRITORY', text: 'Australian Capital Territory'},
                    {value: 'NEWSOUTHWALES', text: 'New South Wales'},
                    {value: 'NORTHERNTERRITORY', text: 'Northern Territory'},
                    {value: 'QUEENSLAND', text: 'Queensland'},
                    {value: 'SOUTHAUSTRALIA', text: 'South Australia'},
                    {value: 'TASMANIA', text: 'Tasmania'},
                    {value: 'VICTORIA', text: 'Victoria'},
                    {value: 'WESTERNAUSTRALIA', text: 'Western Australia'}
                ]
            },
            modal: {
                firstName: undefined,
                lastName: undefined,
                email: undefined,
                password: undefined,
                confirm_password: undefined,
                website: undefined,
                country: undefined,
                address: undefined,
                city: undefined,
                state: undefined,
                zip: undefined,
                phone: undefined,
                promotional: {
                    partnerType: [undefined],
                    websites: [undefined],
                    appLinks: [undefined],
                    listSocial: [
                        {
                            name: 'Facebook',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Twitter',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Instagram',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Pinterest',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Linkedin',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Youtube',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Tiktok',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Twitch',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Wechat',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                        {
                            name: 'Weibo',
                            image: '',
                            checked: false,
                            url: undefined
                        },
                    ]
                },
                reCaptchaToken: '',
            },
            hasWebsite: true,
            hasAppLink: false,
            hasSocialNetwork: true,
            loadingForm: false,
            validate: {
                email: {
                    status: '',
                    help: ''
                }
            },
            faqs: [
                {
                    title: 'What is Bingtrade?',
                    desc: 'We provide high-quality sports streaming service.'
                },
                {
                    title: 'Does it cost anything to be an affiliate?',
                    desc: 'Nope! Signing up and participating as a Bingtrade affiliate is completely free. Plus, there are no minimum sales required to earn commission.'
                },
                {
                    title: 'Do I need to be a Bingtrade customer?',
                    desc: 'We would love it if you used Bingtrade yourself, but you are not required to be a Bingtrade customer in order to be a part of the Bingtrade Affiliate Program.'
                },
                {
                    title: 'How to start inviting friends to subscribe for BingTrade packages',
                    desc: "- After completing the registration for BingTrade's Partner program, you will be given a Referral Link to invite your friends to sign up for BingTrade's service package.\n- You can update the number of successful purchases made through your Referral Link on our intuitive and easy-to-follow dashboard.\n- When the customer successfully buys the service, you will immediately receive a commission. This amount is counted on a monthly basis......"
                },
            ],
            faqActive: 0
        };
    },
    mounted() {
        let anchorlinks = document.querySelectorAll('a[href^="#"]')

        for (let item of anchorlinks) { // relitere
            item.addEventListener('click', (e)=> {
                let hashval = item.getAttribute('href')
                let target = document.querySelector(hashval)

                window.scroll({
                    top: target.getBoundingClientRect().top + window.scrollY - 80,
                    left: 0,
                    behavior: 'smooth'
                });
                //history.pushState(null, null, hashval)
                e.preventDefault()
            })
        }

        const resizeObserver = new ResizeObserver(entries => {
            this.sendEventToParent('change_height', entries[0].target.scrollHeight);
        });
        resizeObserver.observe(document.querySelector('.body7'));

        /*this.$data.modal = {
            firstName: 'Nguyen',
            lastName: 'Thiet',
            email: 'nvthiet95@gmail.com',
            password: '111111',
            confirm_password: '111111',
            website: 'https://a.com',
            country: 'Vietnam',
            address: undefined,
            city: undefined,
            state: undefined,
            zip: undefined,
            phone: undefined,
            promotional: {
                partnerType: ['Email'],
                websites: ['https://a.com'],
                appLinks: ['https://a.com'],
                listSocial: [
                    {
                        name: 'Facebook',
                        image: '',
                        checked: true,
                        url: 'https://fb.com'
                    },
                    {
                        name: 'Twitter',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Instagram',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Pinterest',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Linkedin',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Youtube',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Tiktok',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Twitch',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Wechat',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                    {
                        name: 'Weibo',
                        image: '',
                        checked: false,
                        url: undefined
                    },
                ]
            },
        };*/
    },
    methods: {
        sendEventToParent(event, data) {
            console.log(event, data)
            parent.postMessage(JSON.stringify({
                event,
                data
            }), "*");
        },
        onClickFAQ(index) {
            this.faqActive = this.faqActive == index ? -1 : index;
        },
        onChangeTaxOption(e) {
            console.log('radio checked', e.target.value);
        },
        addPartnerType() {
            console.log('before', this.modal.promotional.partnerType);
            this.modal.promotional.partnerType.push(undefined);
        },
        removePartnerType(index) {
            this.modal.promotional.partnerType.splice(index, 1);
        },
        addWebsite() {
            this.modal.promotional.websites.push(undefined);
        },
        removeWebsite(index) {
            this.modal.promotional.websites.splice(index, 1);
        },
        addAppLink() {
            this.modal.promotional.appLinks.push(undefined);
        },
        removeAppLink(index) {
            this.modal.promotional.appLinks.splice(index, 1);
        },
        toggleItemSocial(index) {
            this.modal.promotional.listSocial[index].checked = !this.modal.promotional.listSocial[index].checked;
        },
        onSubmit(e) {
            e.preventDefault();
            this.validate = {
                email: {
                    status: '',
                    help: ''
                }
            }
            if (this.loadingForm) {
                return;
            }

            let data = JSON.parse(JSON.stringify(this.$data.modal));

            if (data.password != data.confirm_password) {
                this.$message.error('Password not match!');
                return;
            }
            if (!data.country) {
                this.$message.error('Country is required!');
                document.querySelector('.country').scrollIntoView();
                return;
            }
            data.promotional.partnerType = data.promotional.partnerType.filter(v => v != null && v != undefined && v != "");
            if (data.promotional.partnerType.length == 0) {
                this.$message.error('Please choose at least one Partner Type!');
                document.querySelector('.partner-type').scrollIntoView();
                return;
            }

            data.promotional.websites = data.promotional.websites.filter(v => v != null && v != undefined && v != "");
            data.promotional.listSocial = data.promotional.listSocial.filter(v => v.url != null && v.url != undefined && v.url != "");
            for (let i = 0; i < data.promotional.listSocial.length; i++) {
                delete data.promotional.listSocial[i].checked;
                delete data.promotional.listSocial[i].image;
            }
            if (data.promotional.websites.length == 0 && data.promotional.listSocial.length == 0) {
                this.$message.error('Website or Social link is required!');
                document.querySelector('.property-type').scrollIntoView();
                return;
            }

            /*if (!this.modal.reCaptchaToken) {
                this.$message.error('Captcha invalid!');
                return;
            }*/

            data.promotional.appLinks = data.promotional.appLinks.filter(v => v != null && v != undefined && v != "");

            console.log('data', data);

            this.loadingForm = true;

            this.$http.post(`https://admin.ttbd.live/api/v1/signup-reseller?site_name=${this.getParameterByName('site_name')}`, data).then((response) => {
                alert(response.data.msg);
                location.reload();
            }).catch(error => {
                if (error.response.data.email) {
                    this.validate.email.status = 'error';
                    this.validate.email.help = error.response.data.email.join(', ');
                    document.querySelector('[type="email"]').scrollIntoView();
                }
                this.modal.reCaptchaToken = '';
                // this.$refs.recaptcha.reset();
                this.loadingForm = false;
                alert('ERROR');
            });
        },
        getParameterByName(name) {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            return params.get(name);
        },
        reCaptchaVerify(token) {
            this.modal.reCaptchaToken = token;
        }
    },
}
